export const taxModalIntialValue = {
  taxIdOption: '',
  companyTaxId: '',
  individualTaxId: '',
  taxIdCNPJ: '',
  taxIdCPF: '',
  stateTaxId: '',
  neighborhood: ''
};

export const COUNTRY_CODE = {
  brazil: 'BR'
};
